module.exports = __webpack_public_path__ + "static/img/aboutUs07.cdd9f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs07.jpg
// module id = 1359
// module chunks = 1